module.exports = __webpack_public_path__ + "assets/img/tx121.758cf71a.jpg";